import { z } from 'zod';
import { digest, id } from '../models/common.mjs';

// Browser-safe original operation references. The digest expresses the exact
// retained candidate expectation; it never supplies permission or Check proof.
export const finishCandidateReferenceSchema = z
  .object({ artifactId: id, candidateRef: id, operationId: id })
  .strict();
export const finishArtifactInputSchema = finishCandidateReferenceSchema.extend({
  inputDigest: digest,
});
export const finishArtifactReceiptInputSchema = z
  .object({ artifactId: id, operationId: id, inputDigest: digest })
  .strict();
